import React, { Component } from 'react';
import { connect } from 'react-redux';

// API
import * as API from '../../utils/api';

// Components
import AdminPortal from './AdminPortal';
import ProfileList from '../../components/Admin/ProfileList';

class AdminProfileList extends Component {
  state = {
    profiles: [],
    isLoading: true
  }

  componentDidMount() {
    const { currentUser } = this.props

    API.adminProfiles(currentUser)
    .then(profiles => this.setState({ isLoading: false, profiles }))
  }

  removeProfile = (userName) => {
    this.setState(prevState => (
      {
        profiles: prevState.profiles.filter(profile => profile.username !== userName)
      }
    ))
  }

  render() {
    const { appName, path } = this.props
    const { isLoading, profiles } = this.state;

    return (
      <AdminPortal appName={appName} isLoading={isLoading} path={path}>
        <section className="admin">
          <div className="inner-wrap">
            <h4>Admin Portal</h4>
            <h1>Profiles</h1>
            <ProfileList profiles={profiles} onDeleteClicked={this.removeProfile} />
          </div>
        </section>
      </AdminPortal>
    )
  }
}

const mapStateToProps = state => ({ currentUser: state.user });

export default connect(mapStateToProps)(AdminProfileList);



// WEBPACK FOOTER //
// ./src/screens/Admin/AdminProfileList.js